<template>
    <v-container>

        <v-layout row justify-center>
            <v-dialog v-model="isLoading" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
                <v-layout row justify-center align-center>
                <v-progress-circular :rotate="90" :value="progressValue"
                    :size="200" :width="20" color="pink">
                    </v-progress-circular>
                </v-layout>
            </v-container>
            </v-dialog>
        </v-layout>


        <v-layout column>
            <v-flex mb-10>
                <v-layout row>
                    <v-flex>
                        <v-btn color="success"  @click="backToHeader()">
                            <v-icon right>fast_rewind</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <h2>{{ mode == 'new' ? 'New User' : 'View/Update User' }}</h2> 
                    </v-flex>
                </v-layout>

            </v-flex>
            <v-flex v-if="userLocal">

                <v-layout column>

                    <v-flex v-if="showMessage">
                        <div :class="{'dv-message':true,'errorMessage':errorMessage}">
                            {{ message }}
                        </div>
                    </v-flex>

                    <v-flex v-if="saved" >
                        <input type="file" style="display:none" ref="fileInput" accept="*/*"
                                @change="onFilePicked">
                        <img :src="userLocal.thumbUrl" class="user-image" @click="onPickFile">
                    </v-flex>

                    <v-flex mb-5>
                        <div  v-if="mode == 'new'" >
                            <v-layout column>
                                <v-flex>
                                    <v-text-field
                                        v-model="userLocal.email"
                                        label="Email"
                                    ></v-text-field>

                                </v-flex>
                                <v-flex>
                                    <v-text-field
                                        v-model="password"
                                        label="Password"
                                    ></v-text-field>

                                </v-flex>

                            </v-layout>
                        </div>
                        <div v-else>
                            {{ userLocal.email  }}
                        </div>
                    </v-flex>

                    <v-flex v-if="mode == 'update'">

                        <v-layout column>

                            <v-flex>
                                <v-text-field
                                    v-model="userLocal.userName"
                                    label="User Name"
                                ></v-text-field>
                            </v-flex>

                            <v-flex>
                                <v-select
                                    :items="hdTypes"
                                    label="HD Type"
                                    v-model="userLocal.hdType"
                                ></v-select>                        
                            </v-flex>

                            <v-flex>
                                <v-select
                                    :items="userTypes"
                                    label="User Type"
                                    v-model="userLocal.userType"
                                ></v-select>                        
                            </v-flex>

                            <v-flex>
                                <v-select
                                    :items="brands"
                                    label="Brand"
                                    v-model="userLocal.brand"
                                ></v-select>                        
                            </v-flex>

                            <v-flex>
                                <v-select
                                    :items="departments"
                                    item-text="department"
                                    name="department"
                                    v-model="userLocal.department"
                                    label="Department"
                                    class="my-2 pa-0"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.department }}
                                    </template>

                                </v-select>


                            </v-flex>

                            <v-flex>

                                <v-select
                                    :items="sections"
                                    item-text="section"
                                    name="section"
                                    v-model="userLocal.section"
                                    label="Section"
                                    class="my-2 pa-0"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.section }}
                                    </template>

                                </v-select>

                            </v-flex>

                        </v-layout>
                    </v-flex>


                </v-layout>

            </v-flex>

            <v-flex>
                <v-layout row justify-end>
                    <v-flex shrink>
                        <v-btn class="primary" :disabled="disabledBtns"
                            @click="saveUser()">
                            
                            {{ mode == 'update' ? 'Save Updates' : 'Add New User' }}
                        </v-btn>

                    </v-flex>
                    <v-flex shrink ml-5>
                        <v-btn class="warning"   @click="backToHeader">
                            Close
                        </v-btn>

                    </v-flex>
                </v-layout>
            </v-flex>

        </v-layout>

    </v-container>
</template>
<script>

import {mapState} from 'vuex'
const fb = require('../../firebaseConfig.js')
export default {
    props:['user','mode'],
    data(){
        return {
            userLocal:null,
            saved:true,
            userTypes:['client','assignee'],
            hdTypes:['IT','PROD'],
            userFile:null,
            progressValue:0,
            disabledBtns:false,
            isLoading: false,
            password:'',
            message:'',
            showMessage:false,
            errorMessage:false,

        }
    },
    computed:{
        ...mapState(['currentUser','brands','departments','sections'])
    },

    methods:{

        saveUser(){
            
            this.showMessage = false
            this.errorMessage = false
            this.message = ''

            if (this.mode == 'new'){

                if ( this.userLocal.email == '' || this.password == '' ){

                    this.showMessage = true
                    this.errorMessage = true
                    this.message = 'Email and password fields are required!'

                    return
                }

                fb.auth.createUserWithEmailAndPassword(this.userLocal.email, this.password)
                .catch(function(error) {
                    console.log(error)

                    this.showMessage = true
                    this.errorMessage = true
                    this.message = error

                    return

                });
                this.$emit('close',this.userLocal)

                /*
                fb.usersCollection.add({
                    userName: this.userLoca.userName,
                    userType: this.userLocal.userType,
                    email:this.userLocal.email,
                    brand: this.userLocal.brand,
                    department: this.userLocal.department,
                    section: this.userLocal.section,
                    fileUrl:'',
                    thumbUrl:''
                })
                .then(docRef=>{
                    //console.log("docRef issues ", docRef.id);
                    if (docRef.id != ''){
                        //this.$emit('close',docRef.id)
                        this.saved = true

                        this.$emit('close',this.userLocal)

                    }
                })
                .catch(error=>console.log(error))
                */

            }else{

                //console.log("update this.userLocal.id",this.userLocal.id)
                //console.log("update this.userLocal",this.userLocal)
                if ( this.userLocal.userName == '' ){

                    this.showMessage = true
                    this.errorMessage = true
                    this.message = 'User Name field is required!'

                    return
                }

                if (this.userLocal.userType == 'client' &&
                    ( this.userLocal.brand == '' || this.userLocal.department == '' || this.userLocal.section == '' ) ){
                    
                    this.showMessage = true
                    this.errorMessage = true
                    this.message = 'Brand, department, and section fields are required for clients!'

                    return

                }
                console.log("this.userLocal",this.userLocal)
                fb.usersCollection.doc(this.userLocal.id).update({
                    userName: this.userLocal.userName,
                    userType:this.userLocal.userType,
                    hdType:this.userLocal.hdType,
                    brand: this.userLocal.brand,
                    department:this.userLocal.department,
                    section: this.userLocal.section,
                })

                this.user.userName = this.userLocal.userName
                this.user.userType = this.userLocal.userType
                this.user.hdType = this.userLocal.hdType
                this.user.brand = this.userLocal.brand
                this.user.department = this.userLocal.department
                this.user.section = this.userLocal.section

            }


        },

         onPickFile(){
            this.$refs.fileInput.click()
        },

         onFilePicked(event){

            console.log("clicked")
            const files = event.target.files
            //console.log("files",files[0])
            let filename = files[0].name
            if (filename.lastIndexOf('.') <= 0){
                return alert('Please add a valid file')
            }
            this.userFile = files[0]

            this.uploadFile();

        },
        uploadFile(){

            let id = this.user.id
            //console.log("this.issueFile",this.issueFile)
            this.isLoading = true;
            this.progressValue = 10;
            this.disabledBtns = true;

            let ref = fb.storage.ref().child('userFiles')

            let data = {
              etag: id,
              customMetadata: {
                  'imageId': id,
                  'fileName': this.userFile.name,
                  'collection':'users'
                }  
            };

            var uploadTask = ref.child(this.userFile.name).put(this.userFile,data);

            var self = this;

            uploadTask.on('state_changed',function(snapshot){

              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              //console.log('Upload is ' + progress + '% done');
              self.progressValue = Math.round(progress);

            },function(error){
              console.log(error.message);
              this.disabledBtns = false;

            },function(){

              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
                //his.downloadURL = downloadURL;
                //console.log("this.downloadURL",downloadURL);
                
                fb.usersCollection.doc(id).update({
                  fileUrl:downloadURL,
                  thumbUrl:''
                })

                self.isLoading = false;
                self.disabledBtns = false;

                setTimeout(()=>{
                    self.getUserThumbUrl();
                },2500);

              });
            });


        },

        getUserThumbUrl(){
            
            let url = ''

            fb.usersCollection.doc(this.user.id).get()
            .then(doc=>{

                console.log("user doc",doc)
                url = doc.data().thumbUrl
                
                this.userLocal.thumbUrl = url

            })
            .catch(err=>{
                console.log(err)
            })
        },

        backToHeader(){
            this.$emit('close')
        },

    },
    mounted(){
        console.log("Mounted UserDet");
        //console.log("this.currentUser",this.currentUser.email)
        console.log("this.mode",this.mode)
        if (this.mode == 'new'){
            this.saved = false
            this.userLocal = {
                id:'',
                userID:'',
                userName:'',
                userType:'',
                email:'',
                brand:'',
                department:'',
                section:'',
                picUrl:'',
                picThumbUrl:''
            }
        }else{
            this.saved = true
            this.userLocal = this.user
        }
        console.log("this.userLocal",this.userLocal)
    }
}
</script>
<style scoped>
.user-image{
    width: 100px;
    height: 120px;
    border: 1px solid gray;
    border-radius: 10px;
    cursor: pointer;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

</style>